/**
 *
 * FlashCardLanding
 *
 */

import MainModeFlashCardItem from '@/views/MainMode/MainModeCourse/MainModeFlashCardLanding/components/MainModeFlashCardItem.vue';
import { FlashCardFavoriteMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/FlashCardFavoriteMixin';

export default {
  name: 'MainModeFlashCardFavorite',

  mixins: [FlashCardFavoriteMixin],

  components: {
    MainModeFlashCardItem,
  },
};
